import { render } from "./AdmissionFeeReminderAlert.vue?vue&type=template&id=695ea1a8"
import script from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"
export * from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v2/Modal/AdmissionFeeReminderAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "695ea1a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('695ea1a8', __exports__)) {
    api.reload('695ea1a8', __exports__)
  }
  
  module.hot.accept("./AdmissionFeeReminderAlert.vue?vue&type=template&id=695ea1a8", () => {
    api.rerender('695ea1a8', render)
  })

}


export default __exports__